import {
  Stack,
  HStack,
  Box,
  Button,
  Heading,
  Text,
  chakra,
  AspectRatio,
} from "@chakra-ui/react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import TextField from "./TextField";
import * as Yup from "yup";
// import addToMailchimp from "gatsby-plugin-mailchimp";
// import lowerBg from "./lowerBg.svg";
import Image from "next/image";

const FormImage = chakra(Image, {
  baseStyle: {
    maxWidth: "40%",
    overflow: "hidden",
  },
  shouldForwardProp: (prop) =>
    ["width", "height", "src", "alt", "layout"].includes(prop),
});

const InlineForm = () => {
  const validate = Yup.object({
    email: Yup.string()
      .email("Please provide a valid email address")
      .required("A valid email address is required"),
  });
  const verifyCallback = (response) => {
    console.log(response);
  };
  return (
    <Stack borderColor="brand.500" borderWidth="5px" my={8}>
      <Stack py={6} px={6} direction="row">
        <AspectRatio ratio={16 / 9} w="50%">
          <FormImage
            src="/Tom-Smith-Lewis-Cook.jpg"
            alt="Tom Smith & Lewis Cook"
            layout="fill"
            objectFit="cover"
          />
        </AspectRatio>
        <Box textAlign="center" px={8}>
          <Heading
            fontSize="1.5rem"
            fontWeight="normal"
            color="rgba(0,0,0,0.8)"
          >
            Keep It New Program
          </Heading>
          <Text fontSize="14px" fontWeight="normal" color="rgba(0,0,0,0.5)">
            FREE Maintenance For 3-Years!
          </Text>
          <Text fontSize="14px" fontWeight="normal" color="rgba(0,0,0,0.5)">
            It's a $1,300 value only at Martin Chevrolet.
          </Text>
          <Text fontSize="14px" fontWeight="normal" color="rgba(0,0,0,0.5)">
            Subscribe to the <em>iDriveSoCal</em> newsletter and we'll email the
            offer.
          </Text>
        </Box>
      </Stack>
      <Stack>
        <Formik
          initialValues={{
            email: "",
          }}
          validationSchema={validate}
          onSubmit={async (values) => {
            const result = await axios.post("/api/newsletter", values);
            console.log(result);
          }}
        >
          {(formik) => (
            <HStack
              as={Form}
              bgColor="brand.400"
              pt={9}
              pb={8}
              px={8}
              spacing="0.8rem"
            >
              <TextField
                size="md"
                type="email"
                label="Email"
                name="email"
                placeholder="Email"
              />
              <Button
                size="md"
                colorScheme="brand"
                textTransform="uppercase"
                type="submit"
                px={8}
              >
                Subscribe!
              </Button>
            </HStack>
          )}
        </Formik>
      </Stack>
    </Stack>
  );
};

export default InlineForm;
